export enum ClauseTab {
  DOCUMENT_INFO = "documentInfo",
  SIMILAR_CLAUSES = "similarClauses",
  COMMENTS = "comments",
}
